<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script type="text/javascript">
import ls from "@/common/localStorage";
var Session_UserId = ls.getSessionValueByKey("UserId");
var Session_UserName = ls.getSessionValueByKey("Name");
var Event_Name = ls.getSessionValueByKey("Session_Event_FullName");
var Event_Id = ls.getSessionValueByKey("Session_Event_Id");

!(function (e, t, r, n) {
  if (!e[n]) {
    for (
      var a = (e[n] = []),
        i = [
          "survey",
          "reset",
          "config",
          "init",
          "set",
          "get",
          "event",
          "identify",
          "track",
          "page",
          "screen",
          "group",
          "alias",
        ],
        s = 0;
      s < i.length;
      s++
    ) {
      var c = i[s];
      a[c] =
        a[c] ||
        (function (e) {
          return function () {
            var t = Array.prototype.slice.call(arguments);
            a.push([e, t]);
          };
        })(c);
    }
    a.SNIPPET_VERSION = "1.0.1";
    var o = t.createElement("script");
    (o.type = "text/javascript"),
      (o.async = !0),
      (o.src =
        "https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/" +
        r +
        "/" +
        n +
        ".js");
    var p = t.getElementsByTagName("script")[0];
    p.parentNode.insertBefore(o, p);
  }
})(window, document, "sVBTeogNKdjN8MmV", "delighted");
if (Event_Name != undefined) {
  delighted.survey({
    email: Session_UserId, // customer email (optional)
    name: Session_UserName, // customer name (optional)
    properties: {
      // extra context (optional)
      eventName: Event_Name,
      eventID: Event_Id,
    },
  });
}
</script>

<script>
import themeConfig from "@/../themeConfig.js";
import jwt from "@/http/requests/auth/jwt/index.js";
import ls from "@/common/localStorage";
let OnlyGeoCheckinModule = ls.getSessionValueByKey("UseOnlyGeoCheckinModule");
OnlyGeoCheckinModule = JSON.parse(OnlyGeoCheckinModule);
var counter = 0;
var isTabActive = true;
var pageExpireMinutes = 30;
export default {
  data() {
    return {
      vueAppClasses: OnlyGeoCheckinModule ? ["checkin-nav-menu"] : [],
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
  },
  methods: {
    toggleClassInBody(className) {
      if (className === "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className === "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.onfocus = function () {
      isTabActive = true;
      if (counter >= pageExpireMinutes) {
        window.location.reload();
      }
    };
    window.onblur = function () {
      isTabActive = false;
    };
    setInterval(function () {
      counter++;
      if (counter >= pageExpireMinutes) {
        if (isTabActive) {
          window.location.reload();
        }
      }
    }, 60000);
  },
  async created() {
    const dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    // Auth0
    try {
      await this.$auth.renewTokens();
    } catch (e) {
      console.error(e);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
